import { TagsValidation } from "../models";

import { checkTagExistence } from "./checkTagExistence";

const maxTagsNumber = 8;

export const validateTagDupesAndLimit =
    (tagName: string, tags: readonly string[]) =>
    (tagsValidation: TagsValidation): TagsValidation => {
        if (tagsValidation !== TagsValidation.Valid) {
            return tagsValidation;
        }

        if (tags.length >= maxTagsNumber) {
            return TagsValidation.LimitReached;
        } else if (checkTagExistence(tagName, tags)) {
            return TagsValidation.Exist;
        }

        return TagsValidation.Valid;
    };
